import { Checkbox } from '@/ui/Checkbox';

import { Wrapper } from '../shared';

const Widget = ({ disabled, onChange, value, readonly, name }) => (
	<Checkbox
		name={name}
		onCheckedChange={onChange}
		checked={value}
		disabled={disabled || readonly}
	/>
);

const CheckboxWidget = (props) => {
	const { value, onChange } = props;

	return (
		<Wrapper value={value} onChange={onChange}>
			<Widget {...props} />
		</Wrapper>
	)
}

export { CheckboxWidget };
